(function () {
  'use strict';

  if (window.bbCartActionsInit) return;
  window.bbCartActionsInit = true;

  var overlay  = null;
  var locPopup = null;
  var delPopup = null;
  var sumPopup  = null;
  var sumCfg    = null;
  var shipCfg   = null;
  var titleCfg  = null;

  var scarCfg       = null;
  var scarItems     = [];
  var scarIdx       = 0;
  var scarSession   = 0;
  var scarTimer     = null;

  // ── Init ───────────────────────────────────────────────────────────────────
  function init() {
    overlay  = document.getElementById('bb-cta-overlay');
    locPopup = document.getElementById('bb-loc-popup');
    delPopup = document.getElementById('bb-del-popup');
    sumPopup = document.getElementById('bb-summary-popup');
    sumCfg   = parseSummaryCfg();
    shipCfg  = parseShipCfg();
    titleCfg = parseTitleCfg();
    if (titleCfg && titleCfg.locShowLabel) initLocLabel();
    initScarcityNotif();
    initFlashCountdown();

    // Icon button clicks
    document.querySelectorAll('.bb-cti').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.dataset.action;
        if (action === 'map_pin')      openLocPopup();
        if (action === 'trash_remove') handleTrash();
      });
    });

    // Close: overlay click or any [data-bb-close] button
    if (overlay) overlay.addEventListener('click', closeAll);
    document.querySelectorAll('[data-bb-close]').forEach(function (el) {
      el.addEventListener('click', closeAll);
    });

    // Delete popup: No / Yes
    var noBtn  = document.getElementById('bb-del-no');
    var yesBtn = document.getElementById('bb-del-yes');
    if (noBtn)  noBtn.addEventListener('click', closeAll);
    if (yesBtn) yesBtn.addEventListener('click', doRemove);

    // Guest location form: states / provinces follow the country.
    var locCountry = document.getElementById('bb-loc-country');
    if (locCountry) {
      locCountry.addEventListener('change', function () {
        syncGuestProvinces();
        var rd = document.getElementById('bb-loc-rates');
        if (rd) { rd.style.display = 'none'; rd.innerHTML = ''; }
      });
      syncGuestProvinces();
    }

    // Location popup: Confirm / Secondary
    var confirmBtn = document.getElementById('bb-loc-confirm');
    var secBtn     = document.getElementById('bb-loc-secondary');
    if (confirmBtn) confirmBtn.addEventListener('click', handleLocConfirm);
    if (secBtn)     secBtn.addEventListener('click', openLocationDrilldown);

    // Drill-down: back / close / confirm city
    var ddBackBtn    = document.getElementById('bb-loc-dd-back');
    var ddCloseBtn   = document.getElementById('bb-loc-dd-close');
    var ddConfirmBtn = document.getElementById('bb-loc-dd-confirm-city');
    if (ddBackBtn)    ddBackBtn.addEventListener('click', ddGoBack);
    if (ddCloseBtn)   ddCloseBtn.addEventListener('click', closeAll);
    if (ddConfirmBtn) ddConfirmBtn.addEventListener('click', ddConfirmCity);

    // Address card selection (pre-select default)
    initAddressCards();

    // Sticky bar select-all checkbox
    var barCb = document.getElementById('bb-bar-all-cb');
    if (barCb) barCb.addEventListener('change', handleBarSelectAll);

    // Sticky bar checkout button
    var barBtn = document.getElementById('bb-bar-checkout-btn');
    if (barBtn) barBtn.addEventListener('click', handleBarCheckout);

    // Summary popup: chevron open / close
    var chevronBtn = document.getElementById('bb-bar-chevron');
    if (chevronBtn) chevronBtn.addEventListener('click', openSummaryPopup);
    var sumClose = document.getElementById('bb-summary-close');
    if (sumClose) sumClose.addEventListener('click', closeSummaryPopup);

    // Sticky bar: update on checkbox changes
    document.addEventListener('change', function (e) {
      if (e.target.classList.contains('bb-sel-input')) {
        updateBarFromSelection();
      }
    });

    // Sticky bar: refresh cache + update on cart changes
    document.addEventListener('cart:updated', function () {
      burstRateCache();
      refreshCart().then(function() {
        updateBarFromSelection();
        if (locationNoRates) setTimeout(applyAvailabilityUI, 120);
        collectScarItems();
      });
    });

    // Initial load — wait briefly for Select-B to restore state from localStorage
    refreshCart().then(function () {
      setTimeout(function() {
        prefetchAddressRates();
        updateBarFromSelection();
      }, 250);
    });
  }

  // ── Overlay / open / close helpers ────────────────────────────────────────
  // Page lock shared with the other overlays (bb-overlay-coordinator.js).
  function pageLock(id) {
    if (window.BBOverlay) window.BBOverlay.lock(id);
    else document.body.style.overflow = 'hidden';
  }

  function pageUnlock(id) {
    if (window.BBOverlay) window.BBOverlay.unlock(id);
    else document.body.style.overflow = '';
  }

  function openOverlay() {
    if (overlay) overlay.classList.add('is-active');
    pageLock('cart:tools');
  }

  function closeAll() {
    pendingRemoval = null;
    if (overlay)  overlay.classList.remove('is-active');
    if (locPopup) { locPopup.classList.remove('is-open'); locPopup.setAttribute('aria-hidden', 'true'); }
    if (delPopup) { delPopup.classList.remove('is-open'); delPopup.setAttribute('aria-hidden', 'true'); }
    if (sumPopup) { sumPopup.classList.remove('is-open'); sumPopup.setAttribute('aria-hidden', 'true'); }
    var dd = document.getElementById('bb-loc-drilldown');
    if (dd) { dd.classList.remove('is-open'); dd.setAttribute('aria-hidden', 'true'); }
    var chev = document.getElementById('bb-bar-chevron');
    if (chev) chev.classList.remove('is-open');
    pageUnlock('cart:tools');
  }

  // ── Location popup ─────────────────────────────────────────────────────────
  function openLocPopup() {
    if (!locPopup) return;
    openOverlay();
    locPopup.classList.add('is-open');
    locPopup.setAttribute('aria-hidden', 'false');
  }

  function initAddressCards() {
    document.querySelectorAll('.bb-loc-addr-card').forEach(function (card) {
      if (card.classList.contains('bb-loc-addr-card--dflt')) selectCard(card);
      card.addEventListener('click', function () { selectCard(card); });
    });
  }

  function selectCard(card) {
    document.querySelectorAll('.bb-loc-addr-card').forEach(function (c) {
      c.classList.remove('is-selected');
    });
    card.classList.add('is-selected');
  }

  function handleLocConfirm() {
    var isLoggedIn = !!document.getElementById('bb-loc-addrs');

    if (isLoggedIn) {
      // Store selected address data, close popup
      var selected = document.querySelector('.bb-loc-addr-card.is-selected');
      if (selected) {
        try {
          sessionStorage.setItem('bb_ship_addr', JSON.stringify({
            id: selected.dataset.addrId,
            zip: selected.dataset.zip,
            country: selected.dataset.country,
            province: selected.dataset.province,
            city: selected.dataset.city || ''
          }));
        } catch (e) {}
      }
      closeAll();
      burstRateCache();
      locationNoRates = false;
      applyAvailabilityUI();
      updateBarFromSelection();
      prefetchAddressRates(true); // saved address — skip unavail check, just refresh rates/bar
      updateLocLabel();
    } else {
      // Guest: run shipping rate lookup
      calcGuestRates();
    }
  }

  // Shipping rates arrive as a decimal string plus their own currency code.
  function formatRatePrice(rate) {
    var amount = parseFloat(rate.price);
    if (rate.currency && typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: rate.currency }).format(amount);
      } catch (e) { /* fall through */ }
    }
    return formatMoney(Math.round(amount * 100));
  }

  // Guest form: the selected country's states / provinces (Shopify's own
  // list, on the option as data-provinces). Shown only for countries that
  // have them; a US lookup without a state is refused by Shopify.
  function provincesFor(select) {
    var opt = select && select.options[select.selectedIndex];
    if (!opt) return [];
    try {
      var list = JSON.parse(opt.getAttribute('data-provinces') || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function syncGuestProvinces() {
    var countryEl = document.getElementById('bb-loc-country');
    var row       = document.getElementById('bb-loc-province-row');
    var provEl    = document.getElementById('bb-loc-province');
    if (!countryEl || !row || !provEl) return;
    var list = provincesFor(countryEl);
    var keep = provEl.value;
    provEl.innerHTML = '';
    row.hidden = list.length === 0;
    if (!list.length) return;
    provEl.appendChild(new Option('Select…', ''));
    list.forEach(function (p) { provEl.appendChild(new Option(p[1], p[0], false, p[0] === keep)); });
  }

  function rateMessage(ratesDiv, text, isError) {
    ratesDiv.style.display = 'block';
    ratesDiv.innerHTML = '<span style="color:' + (isError ? '#c00' : '#888') + ';font-size:13px;">' + escHtml(text) + '</span>';
  }

  // Shopify's 422 body is { field: [message] }, already worded for shoppers
  // ("Select a state", "Enter a valid ZIP code for California, United States").
  function rateErrorText(body) {
    var parts = [];
    if (body && typeof body === 'object') {
      Object.keys(body).forEach(function (k) {
        var v = body[k];
        if (Array.isArray(v)) parts = parts.concat(v);
        else if (typeof v === 'string' && k !== 'status') parts.push(v);
      });
    }
    return parts.length ? parts.join(' ') : 'We couldn\u2019t check rates for that address. Check it and try again.';
  }

  /*
    Each outcome is said differently:
      incomplete address  → asks for the missing field (no request)
      calculating         → "Calculating shipping…"
      request refused     → Shopify's reason (bad ZIP, missing state…)
      connection failed   → try again
      no rates (200, [])  → this address has no shipping option
  */
  function calcGuestRates() {
    var countryEl = document.getElementById('bb-loc-country');
    var zipEl     = document.getElementById('bb-loc-zip');
    var provEl    = document.getElementById('bb-loc-province');
    var ratesDiv  = document.getElementById('bb-loc-rates');

    if (!countryEl || !zipEl || !ratesDiv) { closeAll(); return; }

    var zip      = zipEl.value.trim();
    var country  = countryEl.value;
    var needProv = provincesFor(countryEl).length > 0;
    var province = provEl && needProv ? provEl.value : '';

    if (needProv && !province) { rateMessage(ratesDiv, 'Choose a state / province to see rates.', true); provEl.focus(); return; }
    if (!zip) { rateMessage(ratesDiv, 'Enter a ZIP / postal code to see rates.', true); zipEl.focus(); return; }

    rateMessage(ratesDiv, 'Calculating shipping…', false);

    var url = '/cart/shipping_rates.json' +
      '?shipping_address[zip]='     + encodeURIComponent(zip) +
      '&shipping_address[country]=' + encodeURIComponent(country) +
      (province ? '&shipping_address[province]=' + encodeURIComponent(province) : '');

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          // Refused (422: incomplete or invalid address) or a store error.
          rateMessage(ratesDiv, res.status >= 500 ? 'Rates are unavailable right now. Try again in a moment.' : rateErrorText(res.data), true);
          return;
        }
        var rates = (res.data && Array.isArray(res.data.shipping_rates)) ? res.data.shipping_rates : [];
        if (rates.length === 0) {
          rateMessage(ratesDiv, 'No shipping options for this address.', false);
          return;
        }
        ratesDiv.innerHTML = rates.map(function (r) {
          var price = parseFloat(r.price) === 0 ? 'Free' : formatRatePrice(r);
          return '<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:1px solid #eee;">' +
            '<span style="font-size:13px;">' + escHtml(r.name) + '</span>' +
            '<span style="font-size:13px;font-weight:700;">' + price + '</span>' +
            '</div>';
        }).join('');
        // Cache rates for the summary popup
        setCachedRates(country, zip, rates);
        try { sessionStorage.setItem('bb_ship_addr', JSON.stringify({ country: country, zip: zip, province: province, city: '' })); } catch(e2) {}
        locationNoRates = false;
        applyAvailabilityUI();
        updateBarFromSelection();
        updateLocLabel();
      })
      .catch(function () {
        rateMessage(ratesDiv, 'We couldn\u2019t reach the store. Check your connection and try again.', true);
      });
  }

  // ── Trash / delete flow ────────────────────────────────────────────────────
  function handleTrash() {
    var lines = getSelectedItems();
    if (lines.length === 0) {
      showToast('Select items first, then tap trash to remove.');
      return;
    }
    if (!delPopup) return;
    openOverlay();
    delPopup.classList.add('is-open');
    delPopup.setAttribute('aria-hidden', 'false');
  }

  function getSelectedItems() {
    var items = [];
    // Select-A/B uses .bb-sel-input:not(.bb-sel-all-input) on item checkboxes
    var checked = document.querySelectorAll('.bb-sel-input:not(.bb-sel-all-input):checked');
    checked.forEach(function (cb) {
      var row = cb.closest('[data-bb-line-key]') || cb.closest('tr.cart-item');
      if (!row) return;
      var key  = row.getAttribute('data-bb-line-key');
      var line = parseInt(row.getAttribute('data-line'), 10);
      if (key)        items.push({ type: 'key',  value: key });
      else if (!isNaN(line)) items.push({ type: 'line', value: line });
    });
    return items;
  }

  var pendingRemoval = null;

  async function doRemove() {
    var items = pendingRemoval || getSelectedItems();
    pendingRemoval = null;
    if (items.length === 0) { closeAll(); return; }

    closeAll();

    var yesBtn = document.getElementById('bb-del-yes');
    if (yesBtn) yesBtn.disabled = true;

    var keyItems  = items.filter(function (i) { return i.type === 'key'; });
    var lineItems = items.filter(function (i) { return i.type === 'line'; })
                        .sort(function (a, b) { return b.value - a.value; });

    var failures = 0;
    async function removeOne(body) {
      try {
        var r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });
        if (!r.ok) failures++;
      } catch (e) {
        failures++;
      }
    }

    // Waits for any other cart change in progress (BBCart in cart.js).
    var run = window.BBCart ? function (task) { return window.BBCart.run(task); } : function (task) { return task(); };
    await run(async function () {
      for (var i = 0; i < keyItems.length; i++) {
        await removeOne({ id: keyItems[i].value, quantity: 0 });
      }
      for (var j = 0; j < lineItems.length; j++) {
        await removeOne({ line: lineItems[j].value, quantity: 0 });
      }
    });

    // A failure is said out loud rather than hidden behind a reload.
    if (failures) {
      if (yesBtn) yesBtn.disabled = false;
      showToast(failures === 1
        ? "One item couldn't be removed. Please try again."
        : failures + " items couldn't be removed. Please try again.");
      setTimeout(function () { window.location.reload(); }, 2500);
      return;
    }
    window.location.reload();
  }

  // ── Sticky bar ─────────────────────────────────────────────────────────────
  var cachedCart    = null;
  var locationNoRates = false;

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cachedCart = cart; return cart; })
      .catch(function () { return cachedCart || { items: [], total_price: 0, item_count: 0 }; });
  }

  function getCheckedKeySet() {
    var keys = {};
    document.querySelectorAll('.bb-sel-input:not(.bb-sel-all-input):checked').forEach(function (cb) {
      var row = cb.closest('[data-bb-line-key]');
      if (row) { var k = row.getAttribute('data-bb-line-key'); if (k) keys[k] = true; }
    });
    return keys;
  }

  /* Shopify's own money format when the shopper sees the store currency;
     otherwise the browser's currency formatting for the active presentment
     currency. Never a bare "$" for a non-dollar cart. */
  function formatMoney(cents) {
    var cur = null;
    var shopCur = (shipCfg && shipCfg.thresholdCurrency) || null;
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        cur = String(window.Shopify.currency.active).toUpperCase();
      }
    } catch (e) { /* fall through */ }
    if ((!cur || (shopCur && cur === String(shopCur).toUpperCase())) &&
        window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
      return window.Shopify.formatMoney(cents, window.money_format);
    }
    if (cur && typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) { /* fall through */ }
    }
    return (cents / 100).toFixed(2) + (cur ? ' ' + cur : '');
  }

  function updateBarFromSelection() {
    var amountEl = document.getElementById('bb-bar-total-amount');
    var countEl  = document.getElementById('bb-bar-checkout-count');
    var btn      = document.getElementById('bb-bar-checkout-btn');
    if (!amountEl && !countEl) return;

    var cart    = cachedCart || { items: [], total_price: 0, item_count: 0 };
    var keySet  = getCheckedKeySet();
    var total   = 0;
    var count   = 0;

    // Selective checkout is paused, so there are no row checkboxes: the bar
    // describes the whole cart, which is exactly what checkout will contain.
    var hasSelUI = !!document.querySelector('.bb-sel-input:not(.bb-sel-all-input)');
    if (!hasSelUI) {
      cart.items.forEach(function (item) { keySet[item.key] = true; });
    }
    var hasAny  = Object.keys(keySet).length > 0;

    if (hasAny) {
      cart.items.forEach(function (item) {
        if (keySet[item.key]) {
          total += item.line_price;
          count += item.quantity;
        }
      });
    }
    // With selection active and nothing selected: $0.00 / (0)

    if (amountEl) amountEl.textContent = formatMoney(total);
    if (countEl)  countEl.textContent  = count;
    if (btn)      btn.disabled = (count === 0);

    // Unavailability message — overrides savings + progress when location has no rates
    var unavailMsgEl = document.getElementById('bb-bar-unavail-msg');
    if (locationNoRates) {
      var barMsg   = (shipCfg && shipCfg.unavailBarMsg)   || "Can't deliver to this address";
      var barColor = (shipCfg && shipCfg.unavailBarMsgColor) || '#c0392b';
      if (unavailMsgEl) { unavailMsgEl.textContent = barMsg; unavailMsgEl.style.color = barColor; unavailMsgEl.style.display = ''; }
      var savedElU = document.getElementById('bb-bar-saved');
      if (savedElU) savedElU.style.display = 'none';
      var progTrackU = document.getElementById('bb-bar-progress-track');
      if (progTrackU) progTrackU.style.display = 'none';
      var progLblU = document.getElementById('bb-bar-progress-lbl');
      if (progLblU) progLblU.style.display = 'none';
      return;
    }
    if (unavailMsgEl) unavailMsgEl.style.display = 'none';
    var progTrack = document.getElementById('bb-bar-progress-track');
    if (progTrack) progTrack.style.display = '';

    // Savings bar
    var savedEl = document.getElementById('bb-bar-saved');
    if (savedEl) {
      var savings = hasAny ? calcSavings(cart, keySet) : 0;
      if (savings > 0) {
        var lbl = (sumCfg && sumCfg.savingsLabel) ? sumCfg.savingsLabel : 'Saved:';
        savedEl.textContent = lbl + ' ' + formatMoney(savings);
        savedEl.style.display = '';
      } else {
        savedEl.style.display = 'none';
      }
    }

    // Progress bar
    var fillEl = document.getElementById('bb-bar-progress-fill');
    var lblEl  = document.getElementById('bb-bar-progress-lbl');
    if (fillEl || lblEl) {
      if (shipCfg && shipCfg.progressShow !== false) {
        var loc = detectCountry();
        var thresh = loc ? getNumericThresholdForCountry(loc.countryCode) : 0;
        if (thresh > 0 && hasAny) {
          updateProgressBar(total, thresh, fillEl, lblEl);
        } else {
          if (fillEl) fillEl.style.width = '0%';
          if (lblEl)  lblEl.style.display = 'none';
        }
      }
    }
  }

  function handleBarSelectAll(e) {
    // Sync with Select-A/B "select all" checkbox
    var mainAllCb = document.querySelector('.bb-sel-all-input, .bb-sel-all, [data-bb-sel-all]');
    if (mainAllCb) {
      mainAllCb.checked = e.target.checked;
      mainAllCb.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function handleBarCheckout() {
    // Proxy to the existing main checkout button so Select-B logic runs
    var mainBtn = document.querySelector('[data-bb-main-checkout], .cart__checkout-button');
    if (mainBtn) {
      mainBtn.click();
    } else {
      window.location.href = '/checkout';
    }
  }

  // ── Summary popup ──────────────────────────────────────────────────────────
  function parseSummaryCfg() {
    try {
      var el = document.getElementById('bb-summary-cfg');
      return el ? JSON.parse(el.textContent) : {};
    } catch(e) { return {}; }
  }

  function openSummaryPopup() {
    if (!sumPopup) return;
    populateSummary();
    openOverlay();
    sumPopup.classList.add('is-open');
    sumPopup.setAttribute('aria-hidden', 'false');
    var chev = document.getElementById('bb-bar-chevron');
    if (chev) chev.classList.add('is-open');
  }

  function closeSummaryPopup() {
    if (sumPopup) { sumPopup.classList.remove('is-open'); sumPopup.setAttribute('aria-hidden', 'true'); }
    var chev = document.getElementById('bb-bar-chevron');
    if (chev) chev.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    pageUnlock('cart:tools');
  }

  function populateSummary() {
    var cfg      = sumCfg || {};
    var cart     = cachedCart || { items: [] };
    var keySet   = getCheckedKeySet();
    var selected = cart.items.filter(function(i) { return keySet[i.key]; });

    var thumbsEl = document.getElementById('bb-summary-thumbs');
    if (thumbsEl) {
      thumbsEl.innerHTML = selected.map(function(item) {
        var imgUrl = (item.featured_image && item.featured_image.url) ? item.featured_image.url : '';
        if (imgUrl) imgUrl = imgUrl.replace(/(\.(jpe?g|png|gif|webp))(\?.*)?$/i, '_120x120$1');
        return '<div class="bb-sum-thumb" data-item-key="' + escHtml(item.key) + '">' +
          '<div class="bb-sum-thumb__img-wrap">' +
            (imgUrl ? '<img class="bb-sum-thumb__img" src="' + imgUrl + '" alt="" loading="lazy">' : '') +
            (item.quantity > 1 ? '<span class="bb-sum-thumb__qty">\xd7' + item.quantity + '</span>' : '') +
          '</div>' +
          '<span class="bb-sum-thumb__price">' + formatMoney(item.price) + '</span>' +
        '</div>';
      }).join('');

      // Clone badges from cart rows into thumbnails
      thumbsEl.querySelectorAll('.bb-sum-thumb[data-item-key]').forEach(function(thumb) {
        var key = thumb.getAttribute('data-item-key');
        var cartRow = document.querySelector('tr.cart-item[data-bb-line-key="' + key + '"]');
        if (!cartRow) return;
        var badgesEl = cartRow.querySelector('.cart-item__image-container .bb-cart-badges');
        if (!badgesEl || !badgesEl.children.length) return;
        var imgWrap = thumb.querySelector('.bb-sum-thumb__img-wrap');
        if (!imgWrap) return;
        var clone = badgesEl.cloneNode(true);
        clone.removeAttribute('style');
        imgWrap.appendChild(clone);
      });
    }

    var pricesEl = document.getElementById('bb-summary-prices');
    if (!pricesEl) return;

    // Unavailability banner — replaces normal price rows
    if (locationNoRates) {
      var sumMsg = (shipCfg && shipCfg.unavailSumMsg) ||
        'Items cannot be delivered to the selected location. Please update your delivery address.';
      pricesEl.innerHTML =
        '<div class="bb-sum-unavail-banner">' +
          '<div class="bb-sum-unavail-banner__icon">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r=".5" fill="currentColor"/></svg>' +
          '</div>' +
          '<div>' +
            '<div class="bb-sum-unavail-banner__text">' + escHtml(sumMsg) + '</div>' +
            '<button type="button" class="bb-sum-unavail-banner__cta" id="bb-sum-unavail-cta">Update address ↗</button>' +
          '</div>' +
        '</div>';
      var ctaBtn = document.getElementById('bb-sum-unavail-cta');
      if (ctaBtn) ctaBtn.addEventListener('click', function() { closeSummaryPopup(); openLocPopup(); });
      return;
    }

    var itemsTotal = 0;
    var subtotal   = 0;
    selected.forEach(function(item) {
      itemsTotal += item.original_line_price;
      subtotal   += item.final_line_price;
    });
    var discount  = itemsTotal - subtotal;

    var rows = [];
    if (discount > 0) {
      rows.push(
        '<div class="bb-sum-row">' +
          '<span class="bb-sum-row__lbl">' + (cfg.itemsTotalLabel || 'Items total') + '</span>' +
          '<span class="bb-sum-row__val bb-sum-val--strike">' + formatMoney(itemsTotal) + '</span>' +
        '</div>',
        '<div class="bb-sum-row bb-sum-row--discount">' +
          '<span class="bb-sum-row__lbl">' + (cfg.discountLabel || 'Items discount') + '</span>' +
          '<span class="bb-sum-row__val">-' + formatMoney(discount) + '</span>' +
        '</div>'
      );
    } else {
      rows.push(
        '<div class="bb-sum-row">' +
          '<span class="bb-sum-row__lbl">' + (cfg.itemsTotalLabel || 'Items total') + '</span>' +
          '<span class="bb-sum-row__val">' + formatMoney(subtotal) + '</span>' +
        '</div>'
      );
    }
    rows.push(
      '<div class="bb-sum-row">' +
        '<span class="bb-sum-row__lbl">' + (cfg.subtotalLabel || 'Subtotal') + '</span>' +
        '<span class="bb-sum-row__val"' + (discount > 0 ? ' style="font-weight:700;"' : '') + '>' + formatMoney(subtotal) + '</span>' +
      '</div>',
      '<div class="bb-sum-row" id="bb-sum-ship-row">' + buildShipRowLoading(cfg) + '</div>',
      '<div class="bb-sum-row bb-sum-row--total">' +
        '<span class="bb-sum-row__lbl">' + (cfg.estimatedLabel || 'Estimated total') + '</span>' +
        '<span class="bb-sum-row__val">' + formatMoney(subtotal) + '</span>' +
      '</div>'
    );
    pricesEl.innerHTML = rows.join('');
    loadShipRow(subtotal, cfg);
  }

  function calcSavings(cart, keySet) {
    var savings = 0;
    cart.items.forEach(function(item) {
      if (keySet[item.key]) savings += (item.original_line_price - item.final_line_price);
    });
    return savings;
  }

  // ── Title config / location label ──────────────────────────────────────────
  function parseTitleCfg() {
    try {
      var el = document.getElementById('bb-title-cfg');
      return el ? JSON.parse(el.textContent) : null;
    } catch(e) { return null; }
  }

  function initLocLabel() {
    var pinBtn = document.querySelector('.bb-cti[data-action="map_pin"]');
    if (!pinBtn) return;
    var pos = (titleCfg && titleCfg.locLabelPos) || 'below';
    pinBtn.classList.add('bb-cti--lbl-' + pos);
    var lbl = document.createElement('span');
    lbl.id = 'bb-loc-label';
    lbl.className = 'bb-loc-label';
    if (titleCfg) {
      lbl.style.color    = titleCfg.locLabelColor || '#555';
      lbl.style.fontSize = (titleCfg.locLabelSize || 10) + 'px';
    }
    pinBtn.appendChild(lbl);
    updateLocLabel();
  }

  function updateLocLabel() {
    var el = document.getElementById('bb-loc-label');
    if (!el) return;
    var text = '';
    try {
      var saved = JSON.parse(sessionStorage.getItem('bb_ship_addr') || '{}');
      if (saved.city)    { text = saved.city; }
      else if (saved.country) { text = saved.country; }
    } catch(e) {}
    if (!text && shipCfg && shipCfg.shopCountryName) text = shipCfg.shopCountryName;
    el.textContent = text;
  }

  // ── Shipping config / country detection ────────────────────────────────────
  function parseShipCfg() {
    try {
      var el = document.getElementById('bb-ship-cfg');
      return el ? JSON.parse(el.textContent) : null;
    } catch(e) { return null; }
  }

  function detectCountry() {
    // Priority 1: address saved by map pin or drill-down
    try {
      var saved = JSON.parse(sessionStorage.getItem('bb_ship_addr') || '{}');
      if (saved.country) {
        // countryCode is set explicitly by drill-down; otherwise infer from length (ISO codes are 2-3 chars)
        var code = saved.countryCode || (saved.country.length <= 3 ? saved.country.toUpperCase() : '') || (shipCfg && shipCfg.shopCountry) || '';
        return { country: saved.country, countryCode: code, zip: saved.zip || '', province: saved.province || '', city: saved.city || '' };
      }
    } catch(e) {}
    // Priority 2: if mode requires address, nothing more we can do
    if (shipCfg && shipCfg.mode === 'require_address') return null;
    // Priority 3: Shopify geolocation embedded from Liquid
    var gc = (shipCfg && shipCfg.shopCountry) || '';
    if (gc) return { country: gc, countryCode: gc, zip: '', province: '', city: '' };
    return null;
  }

  function getThresholdForCountry(countryCode) {
    var t = (shipCfg && shipCfg.thresholds) || {};
    return t[countryCode] || 0;
  }

  /* ── currency safety ────────────────────────────────────────────────────────
     Thresholds are stored in the SHOP's currency, matching how Shopify shipping
     conditions are configured. But cart.total_price and item.line_price arrive
     in the PRESENTMENT currency, and this shop presents EUR to Spain and CAD to
     Canada. Comparing presentment cents against a shop-currency threshold is an
     apples-to-oranges comparison: at the live CAD rate a cart of CAD 60 would
     clear a "5500" threshold while checkout, which converts properly, would not.
     The customer would be promised free shipping and then charged for it.

     Converting here was considered and rejected. It would need this file to
     reproduce Shopify's own rounding of a shipping condition, and no evidence
     available from the storefront proves which currency those conditions are
     denominated in. Checkout is authoritative, and an unprovable conversion
     that renders a confident number is worse than no number.

     So a FIGURE is shown only when presentment == shop currency. Everywhere
     else the threshold still governs nothing numeric, and the UI falls back to
     destination-neutral copy. */
  function currencyIsSafeForNumericThreshold() {
    if (!shipCfg) return false;
    var shopCur   = shipCfg.thresholdCurrency;
    var activeCur = shipCfg.activeCurrency;
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        activeCur = window.Shopify.currency.active;
      }
    } catch (e) { /* fall back to the Liquid-rendered value */ }
    if (!shopCur || !activeCur) return false;
    return String(shopCur).toUpperCase() === String(activeCur).toUpperCase();
  }

  /* Threshold to use for NUMERIC promises: 0 whenever the currency is unsafe,
     so every existing `threshold > 0` caller degrades to calculated shipping
     without needing to know why. */
  function getNumericThresholdForCountry(countryCode) {
    if (!currencyIsSafeForNumericThreshold()) return 0;
    return getThresholdForCountry(countryCode);
  }

  // ── Rate cache (sessionStorage, 10 min TTL) ─────────────────────────────────
  var RATE_TTL = 10 * 60 * 1000;

  function rateKey(country, zip) { return 'bb_rates_' + country + '_' + (zip || ''); }

  function getCachedRates(country, zip) {
    try {
      var raw = sessionStorage.getItem(rateKey(country, zip));
      if (!raw) return null;
      var e = JSON.parse(raw);
      if (Date.now() - e.ts > RATE_TTL) { sessionStorage.removeItem(rateKey(country, zip)); return null; }
      return e.rates;
    } catch(e) { return null; }
  }

  function setCachedRates(country, zip, rates) {
    try { sessionStorage.setItem(rateKey(country, zip), JSON.stringify({ rates: rates, ts: Date.now() })); } catch(e) {}
  }

  function burstRateCache() {
    try {
      Object.keys(sessionStorage)
        .filter(function(k) { return k.indexOf('bb_rates_') === 0; })
        .forEach(function(k) { sessionStorage.removeItem(k); });
    } catch(e) {}
  }

  function fetchLiveRates(country, zip, province) {
    var url = '/cart/shipping_rates.json?shipping_address[country]=' + encodeURIComponent(country);
    if (zip)      url += '&shipping_address[zip]='      + encodeURIComponent(zip);
    if (province) url += '&shipping_address[province]=' + encodeURIComponent(province);
    // An empty list only when Shopify answered with one. A refused lookup
    // (no state, bad ZIP) or a failed request is unknown (null), never "no
    // rates": that would mark the cart's items unavailable for the location.
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(r) {
        return r.json().catch(function() { return null; }).then(function(d) {
          return r.ok && d && Array.isArray(d.shipping_rates) ? d.shipping_rates : null;
        });
      })
      .catch(function() { return null; });
  }

  function prefetchAddressRates(skipUnavailCheck) {
    try {
      var saved = JSON.parse(sessionStorage.getItem('bb_ship_addr') || '{}');
      if (!saved.country) return;
      fetchLiveRates(saved.country, saved.zip || '', saved.province || '').then(function(rates) {
        if (rates !== null) {
          setCachedRates(saved.country, saved.zip || '', rates);
          if (!skipUnavailCheck) {
            locationNoRates = (rates.length === 0);
          }
          updateBarFromSelection();
          applyAvailabilityUI();
        }
      });
    } catch(e) {}
  }

  function applyAvailabilityUI() {
    var cfg    = titleCfg || {};
    var tbody  = document.querySelector('table.cart-items__table tbody') ||
                 document.querySelector('.cart-items__table tbody');

    // Always clean up first
    var old = document.getElementById('bb-unavail-hd');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    document.querySelectorAll('.bb-item--unavailable').forEach(function(el) { el.classList.remove('bb-item--unavailable'); });
    document.querySelectorAll('.bb-unavail-reason').forEach(function(el) { if (el.parentNode) el.parentNode.removeChild(el); });

    if (!locationNoRates || cfg.unavailEnable === false) return;

    var rows = tbody
      ? Array.from(tbody.querySelectorAll('tr.cart-item'))
      : Array.from(document.querySelectorAll('tr.cart-item'));
    if (!rows.length) return;

    var title  = escHtml(cfg.unavailTitle     || 'Unavailable');
    var reason = escHtml(cfg.unavailReason    || 'Item not deliverable to the selected address');
    var rmTxt  = escHtml(cfg.unavailRemoveAll || 'Remove all');
    var hdBg   = escHtml(cfg.unavailHdBg      || '#f8f8f8');
    var hdClr  = escHtml(cfg.unavailHdColor   || '#111111');
    var rnClr  = cfg.unavailReasonColor || '#888888';

    // Build section header row
    var hdRow = document.createElement('tr');
    hdRow.id = 'bb-unavail-hd';
    hdRow.className = 'bb-unavail-hd-row';
    hdRow.innerHTML =
      '<td colspan="99" class="bb-unavail-hd-cell">' +
        '<div class="bb-unavail-hd-inner" style="background:' + hdBg + ';color:' + hdClr + ';">' +
          '<span class="bb-unavail-hd-title">' + title + ' (' + rows.length + ')</span>' +
          '<button type="button" class="bb-unavail-rm-all" id="bb-unavail-rm-all">' + rmTxt + '</button>' +
        '</div>' +
      '</td>';

    // Insert header before first item, move all items after it
    var container = tbody || rows[0].parentNode;
    container.insertBefore(hdRow, rows[0]);
    rows.forEach(function(row) { container.appendChild(row); });

    // Style each row and inject reason text
    rows.forEach(function(row) {
      row.classList.add('bb-item--unavailable');
      var detailEl = row.querySelector('.cart-item__details') || row.querySelector('.cart-item__name');
      if (detailEl && !detailEl.querySelector('.bb-unavail-reason')) {
        var p = document.createElement('p');
        p.className = 'bb-unavail-reason';
        p.style.color = rnClr;
        p.innerHTML =
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r=".5" fill="currentColor"/></svg>' +
          reason;
        detailEl.appendChild(p);
      }
    });

    // Wire "Remove all" — confirm, then remove exactly these rows. (It used to
    // tick row checkboxes and reuse the selection trash, which does nothing
    // while selective checkout is paused.)
    var rmBtn = document.getElementById('bb-unavail-rm-all');
    if (rmBtn) {
      rmBtn.addEventListener('click', function() {
        pendingRemoval = rows.map(function (row) {
          var key = row.getAttribute('data-bb-line-key');
          return key ? { type: 'key', value: key } : { type: 'line', value: parseInt(row.getAttribute('data-line'), 10) };
        });
        if (!delPopup) return;
        openOverlay();
        delPopup.classList.add('is-open');
        delPopup.setAttribute('aria-hidden', 'false');
      });
    }
  }

  // ── Progress bar ────────────────────────────────────────────────────────────
  function updateProgressBar(selectedTotal, threshold, fillEl, lblEl) {
    var pct       = Math.min(100, Math.round(selectedTotal / threshold * 100));
    var remaining = threshold - selectedTotal;
    if (fillEl) fillEl.style.width = pct + '%';
    if (lblEl) {
      if (remaining <= 0) {
        lblEl.textContent = (shipCfg && shipCfg.progressDoneLabel) || 'Unlocked free shipping!';
        lblEl.className   = 'bb-bar-progress-lbl is-free';
      } else {
        lblEl.textContent = formatMoney(remaining) + ' ' + ((shipCfg && shipCfg.progressLabel) || 'away from free shipping');
        lblEl.className   = 'bb-bar-progress-lbl';
      }
      lblEl.style.display = '';
    }
  }

  // ── Live shipping row in summary popup ──────────────────────────────────────
  function loadShipRow(selectedSubtotal, cfg) {
    var row = document.getElementById('bb-sum-ship-row');
    if (!row) return;

    var loc = detectCountry();

    if (!loc) {
      row.innerHTML = buildShipRowNoLocation(cfg);
      var prompt = document.getElementById('bb-sum-ship-prompt');
      if (prompt) prompt.addEventListener('click', function() { closeSummaryPopup(); openLocPopup(); });
      return;
    }

    var cached = getCachedRates(loc.country, loc.zip);
    if (cached !== null) {
      row.innerHTML = buildShipRowFromRates(cached, selectedSubtotal, cfg);
      return;
    }

    // Fetch live
    fetchLiveRates(loc.country, loc.zip, loc.province).then(function(rates) {
      if (rates !== null) setCachedRates(loc.country, loc.zip, rates);
      var r = document.getElementById('bb-sum-ship-row');
      if (r) r.innerHTML = buildShipRowFromRates(rates, selectedSubtotal, cfg);
    });
  }

  function buildShipRowLoading(cfg) {
    return '<span class="bb-sum-row__lbl">' + ((cfg && cfg.shippingLabel) || 'Shipping') + '</span>' +
           '<span class="bb-sum-row__val" style="color:#aaa;font-size:12px;">Estimating…</span>';
  }

  function buildShipRowNoLocation(cfg) {
    var requiresAddr = shipCfg && shipCfg.mode === 'require_address';
    return '<span class="bb-sum-row__lbl">' + ((cfg && cfg.shippingLabel) || 'Shipping') + '</span>' +
      (requiresAddr
        ? '<span id="bb-sum-ship-prompt" class="bb-sum-row__val" style="color:#c0392b;font-size:12px;cursor:pointer;text-decoration:underline;">Set location ↗</span>'
        : '<span class="bb-sum-row__val" style="color:#888;">' + ((cfg && cfg.calcText) || 'Calculated at checkout') + '</span>');
  }

  function buildShipRowFromRates(rates, selectedSubtotal, cfg) {
    // Check if selected items qualify for free shipping by country threshold
    var loc       = detectCountry();
    var threshold = loc ? getNumericThresholdForCountry(loc.countryCode) : 0;
    var qualifies = threshold > 0 && selectedSubtotal >= threshold;

    if (qualifies) {
      return '<span class="bb-sum-row__lbl">' + ((cfg && cfg.shippingLabel) || 'Shipping') + '</span>' +
             '<span class="bb-sum-row__val" style="color:#27ae60;font-weight:700;">' + ((cfg && cfg.freeText) || 'Free') + '</span>';
    }
    if (!rates || rates.length === 0) {
      return '<span class="bb-sum-row__lbl">' + ((cfg && cfg.shippingLabel) || 'Shipping') + '</span>' +
             '<span class="bb-sum-row__val" style="color:#888;">' + ((cfg && cfg.calcText) || 'Calculated at checkout') + '</span>';
    }
    var cheapest  = rates.slice().sort(function(a, b) { return parseFloat(a.price) - parseFloat(b.price); })[0];
    var ratePrice = parseFloat(cheapest.price);
    if (ratePrice === 0) {
      return '<span class="bb-sum-row__lbl">' + ((cfg && cfg.shippingLabel) || 'Shipping') + '</span>' +
             '<span class="bb-sum-row__val" style="color:#27ae60;font-weight:700;">' + ((cfg && cfg.freeText) || 'Free') + '</span>';
    }
    return '<span class="bb-sum-row__lbl">' + ((cfg && cfg.shippingLabel) || 'Shipping') + '</span>' +
           '<span class="bb-sum-row__val" style="font-weight:600;">' + formatMoney(Math.round(ratePrice * 100)) + '</span>';
  }

  // ── Location Drill-Down (Country → Province → City) ───────────────────────

  var DD = { step: 0, country: null, province: null };

  // Mini lookup for the threshold countries in case opt.value is the full name.
  // Spain is included because it carries its own threshold; a missing entry here
  // would leave getThresholdForCountry('ES') resolving to 0.
  var DD_NAME_TO_CODE = {
    'united states': 'US', 'canada': 'CA', 'united kingdom': 'GB',
    'australia': 'AU', 'germany': 'DE', 'france': 'FR', 'mexico': 'MX',
    'spain': 'ES', 'españa': 'ES'
  };

  function openLocationDrilldown() {
    var dd = document.getElementById('bb-loc-drilldown');
    if (!dd) return;
    DD.step = 0; DD.country = null; DD.province = null;
    var srch = document.getElementById('bb-loc-dd-search');
    if (srch) { srch.value = ''; if (srch._ddHandler) { srch.removeEventListener('input', srch._ddHandler); srch._ddHandler = null; } }
    renderDDCountries();
    dd.classList.add('is-open');
    dd.setAttribute('aria-hidden', 'false');
  }

  function closeDrilldown() {
    var dd = document.getElementById('bb-loc-drilldown');
    if (dd) { dd.classList.remove('is-open'); dd.setAttribute('aria-hidden', 'true'); }
  }

  function ddGoBack() {
    if (DD.step === 0) { closeDrilldown(); return; }
    DD.step -= 1;
    var srch = document.getElementById('bb-loc-dd-search');
    if (srch) { srch.value = ''; if (srch._ddHandler) { srch.removeEventListener('input', srch._ddHandler); srch._ddHandler = null; } }
    if (DD.step === 0) { DD.country = null; DD.province = null; renderDDCountries(); }
    else if (DD.step === 1) { DD.province = null; renderDDProvinces(); }
  }

  function getFlagEmoji(code) {
    if (!code || code.length !== 2) return '';
    try {
      return code.toUpperCase().replace(/./g, function(c) {
        return String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65);
      });
    } catch(e) { return ''; }
  }

  function getCountriesFromSelect() {
    var select = document.getElementById('bb-loc-dd-countries') || document.getElementById('bb-loc-country');
    if (!select) return [];
    var result = [];
    Array.from(select.options).forEach(function(opt) {
      if (!opt.value) return;
      var prov = [];
      try {
        var raw = opt.getAttribute('data-provinces');
        if (raw && raw.length > 2) prov = JSON.parse(raw);
      } catch(e) {}
      result.push({ code: opt.value, name: opt.text.trim(), provinces: prov });
    });
    return result;
  }

  function renderDDCountries() {
    updateDDTitle('Select country / region');
    updateDDBreadcrumb('');
    var currentCode = '';
    try {
      var saved = JSON.parse(sessionStorage.getItem('bb_ship_addr') || '{}');
      currentCode = saved.countryCode || saved.country || (shipCfg && shipCfg.shopCountry) || '';
    } catch(e) { currentCode = (shipCfg && shipCfg.shopCountry) || ''; }

    var countries = getCountriesFromSelect();
    var listEl = document.getElementById('bb-loc-dd-list');
    if (!listEl) return;

    renderDDListItems(listEl, countries.map(function(c) {
      var flag = getFlagEmoji(c.code);
      return {
        key: (c.name.match(/[A-Za-z]/) || ['#'])[0].toUpperCase(),
        label: (flag ? flag + ' ' : '') + c.name,
        isChecked: (c.code.toUpperCase() === currentCode.toUpperCase()),
        data: c
      };
    }), function(item) {
      DD.country = item.data;
      var srch = document.getElementById('bb-loc-dd-search');
      if (srch) { srch.value = ''; if (srch._ddHandler) { srch.removeEventListener('input', srch._ddHandler); srch._ddHandler = null; } }
      if (item.data.provinces && item.data.provinces.length > 0) {
        DD.step = 1; renderDDProvinces();
      } else {
        DD.step = 2; renderDDCityForm();
      }
    });
  }

  function renderDDProvinces() {
    if (!DD.country) return;
    updateDDTitle(DD.country.name);
    updateDDBreadcrumb(DD.country.name);
    var listEl = document.getElementById('bb-loc-dd-list');
    if (!listEl) return;

    var skipItem = { key: '#', label: 'Use ' + DD.country.name + ' only', isChecked: false, isSkip: true, data: null };

    renderDDListItems(listEl, [skipItem].concat(DD.country.provinces.map(function(p) {
      return {
        key: (p[1].match(/[A-Za-z]/) || ['#'])[0].toUpperCase(),
        label: p[1],
        isChecked: false,
        isSkip: false,
        data: { code: p[0], name: p[1] }
      };
    })), function(item) {
      if (item.isSkip) { ddSaveLocation(''); return; }
      DD.province = item.data;
      var srch = document.getElementById('bb-loc-dd-search');
      if (srch) { srch.value = ''; if (srch._ddHandler) { srch.removeEventListener('input', srch._ddHandler); srch._ddHandler = null; } }
      DD.step = 2; renderDDCityForm();
    });
  }

  function renderDDCityForm() {
    var listEl   = document.getElementById('bb-loc-dd-list');
    var indexEl  = document.getElementById('bb-loc-dd-index');
    var cityForm = document.getElementById('bb-loc-dd-city-form');
    var srchRow  = document.getElementById('bb-loc-dd-search-row');

    var bc       = DD.country ? DD.country.name : '';
    if (DD.province) bc += ' › ' + DD.province.name;
    var skipName = (DD.province ? DD.province.name : null) || (DD.country ? DD.country.name : '');
    var skipItem = { key: '#', label: 'Use ' + skipName + ' (no specific city)', isChecked: false, isSkip: true, data: null };

    updateDDTitle('Select city');
    updateDDBreadcrumb(bc);

    var srch = document.getElementById('bb-loc-dd-search');
    if (srch) {
      srch.value = ''; srch.placeholder = 'Search city…';
      if (srch._ddHandler) { srch.removeEventListener('input', srch._ddHandler); srch._ddHandler = null; }
    }
    if (srchRow) srchRow.style.display = '';
    if (cityForm) cityForm.style.display = 'none';

    // Show skip + loading immediately while we fetch
    if (listEl) {
      listEl.innerHTML =
        '<div class="bb-loc-dd-sect"><button type="button" class="bb-loc-dd-item bb-loc-dd-item--skip" id="bb-loc-dd-skip-tmp">' +
          '<span class="bb-loc-dd-item-lbl">' + escHtml(skipItem.label) + '</span><span class="bb-loc-dd-skip-arrow">›</span>' +
        '</button></div>' +
        '<div class="bb-loc-dd-loading">Loading cities…</div>';
      var skipTmp = document.getElementById('bb-loc-dd-skip-tmp');
      if (skipTmp) skipTmp.addEventListener('click', function() { ddSaveLocation(''); });
    }
    if (indexEl) indexEl.innerHTML = '';

    fetchCitiesForCountry(DD.country ? DD.country.name : '').then(function(cities) {
      if (!cities || !cities.length) {
        // Fallback: free-text input
        if (listEl)  listEl.innerHTML = '';
        if (indexEl) indexEl.innerHTML = '';
        if (srchRow) srchRow.style.display = 'none';
        if (cityForm) cityForm.style.display = '';
        var cityInput = document.getElementById('bb-loc-dd-city-input');
        if (cityInput) { cityInput.value = ''; setTimeout(function() { cityInput.focus(); }, 150); }
        return;
      }

      renderDDListItems(listEl, [skipItem].concat(cities.map(function(c) {
        return {
          key: (c.match(/[A-Za-z]/) || ['#'])[0].toUpperCase(),
          label: c, isChecked: false, isSkip: false,
          data: { name: c }
        };
      })), function(item) {
        ddSaveLocation(item.isSkip ? '' : item.data.name);
      });
    });
  }

  function fetchCitiesForCountry(countryName) {
    if (!countryName) return Promise.resolve(null);
    var key = 'bb_cities_' + countryName.replace(/\W/g, '_').toLowerCase();
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch(e) {}
    return fetch('https://countriesnow.space/api/v0.1/countries/cities', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ country: countryName })
    })
    .then(function(r) { return r.json(); })
    .then(function(d) {
      if (d && !d.error && Array.isArray(d.data) && d.data.length) {
        try { sessionStorage.setItem(key, JSON.stringify(d.data)); } catch(e2) {}
        return d.data;
      }
      return null;
    })
    .catch(function() { return null; });
  }

  function ddSaveLocation(cityName) {
    var country      = DD.country  ? DD.country.code   : '';
    var countryName  = DD.country  ? DD.country.name   : '';
    var province     = DD.province ? DD.province.code  : '';
    var provinceName = DD.province ? DD.province.name  : '';
    var isoCode = country.length <= 3 ? country.toUpperCase() : (DD_NAME_TO_CODE[countryName.toLowerCase()] || '');
    var displayCity = (cityName || '').trim() || provinceName || countryName;
    try {
      sessionStorage.setItem('bb_ship_addr', JSON.stringify({
        country:     country || countryName,
        countryCode: isoCode,
        zip:         '',
        province:    province,
        city:        displayCity
      }));
    } catch(e) {}
    closeDrilldown();
    closeAll();
    burstRateCache();
    prefetchAddressRates();
    updateLocLabel();
    updateBarFromSelection();
  }

  function ddConfirmCity() {
    var cityInput = document.getElementById('bb-loc-dd-city-input');
    ddSaveLocation(cityInput ? cityInput.value.trim() : '');
  }

  function renderDDListItems(listEl, items, onSelect) {
    // Sort alphabetically (skip leading emoji/symbols)
    var sorted = items.slice().sort(function(a, b) {
      var ka = (a.label.match(/[A-Za-zÀ-ɏ].*/) || [a.label])[0];
      var kb = (b.label.match(/[A-Za-zÀ-ɏ].*/) || [b.label])[0];
      return ka.localeCompare(kb);
    });

    // Group by letter key
    var groups = {}, order = [];
    sorted.forEach(function(item) {
      var k = item.key || '#';
      if (!groups[k]) { groups[k] = []; order.push(k); }
      groups[k].push(item);
    });
    order.sort();

    // Flat list for click-handler mapping
    var flat = [];
    order.forEach(function(l) { flat = flat.concat(groups[l]); });

    // Build list HTML
    var html = '';
    order.forEach(function(letter) {
      html += '<div class="bb-loc-dd-sect" id="bb-loc-dd-sect-' + escHtml(letter) + '">';
      if (letter !== '#') html += '<div class="bb-loc-dd-sect-hd">' + letter + '</div>';
      groups[letter].forEach(function(item) {
        if (item.isSkip) {
          html += '<button type="button" class="bb-loc-dd-item bb-loc-dd-item--skip">' +
            '<span class="bb-loc-dd-item-lbl">' + escHtml(item.label) + '</span>' +
            '<span class="bb-loc-dd-skip-arrow">›</span>' +
          '</button>';
        } else {
          html += '<button type="button" class="bb-loc-dd-item">' +
            '<span class="bb-loc-dd-item-lbl">' + escHtml(item.label) + '</span>' +
            (item.isChecked ? '<span class="bb-loc-dd-check">&#10003;</span>' : '') +
          '</button>';
        }
      });
      html += '</div>';
    });
    listEl.innerHTML = html;
    listEl.scrollTop = 0;

    // Attach click events
    var btns = listEl.querySelectorAll('.bb-loc-dd-item');
    btns.forEach(function(btn, i) {
      btn.addEventListener('click', function() { onSelect(flat[i]); });
    });

    // A-Z index sidebar
    var indexEl = document.getElementById('bb-loc-dd-index');
    if (indexEl) {
      indexEl.innerHTML = order.filter(function(l) { return l !== '#'; }).map(function(l) {
        return '<button type="button" class="bb-loc-dd-idx-btn" data-sect="' + escHtml(l) + '">' + l + '</button>';
      }).join('');
      indexEl.querySelectorAll('.bb-loc-dd-idx-btn').forEach(function(b) {
        b.addEventListener('click', function() {
          var sect = document.getElementById('bb-loc-dd-sect-' + b.dataset.sect);
          if (sect) sect.scrollIntoView({ block: 'start' });
        });
      });
      indexEl.style.display = '';
    }

    // Hide city form, ensure search visible
    var cityForm = document.getElementById('bb-loc-dd-city-form');
    if (cityForm) cityForm.style.display = 'none';
    var srchRow = document.getElementById('bb-loc-dd-search-row');
    if (srchRow) srchRow.style.display = '';

    // Search filtering
    var srch = document.getElementById('bb-loc-dd-search');
    if (srch) {
      if (srch._ddHandler) srch.removeEventListener('input', srch._ddHandler);
      srch._ddHandler = function() {
        var q = srch.value.trim().toLowerCase();
        btns.forEach(function(btn, i) {
          btn.style.display = flat[i].label.toLowerCase().indexOf(q) !== -1 ? '' : 'none';
        });
        listEl.querySelectorAll('.bb-loc-dd-sect').forEach(function(sect) {
          var any = Array.from(sect.querySelectorAll('.bb-loc-dd-item')).some(function(b) { return b.style.display !== 'none'; });
          sect.style.display = any ? '' : 'none';
        });
        if (indexEl) indexEl.style.display = q ? 'none' : '';
      };
      srch.addEventListener('input', srch._ddHandler);
    }
  }

  function updateDDTitle(text) {
    var el = document.getElementById('bb-loc-dd-title');
    if (el) el.textContent = text;
  }

  function updateDDBreadcrumb(text) {
    var el = document.getElementById('bb-loc-dd-breadcrumb');
    if (!el) return;
    el.textContent = text;
    el.style.display = text ? '' : 'none';
  }

  // ── Scarcity Notification Banner ──────────────────────────────────────────
  function parseScarCfg() {
    try {
      var el = document.getElementById('bb-scar-cfg');
      return el ? JSON.parse(el.textContent) : {};
    } catch(e) { return {}; }
  }

  function collectScarItems() {
    var rows = document.querySelectorAll('tr.cart-item[data-bb-line-key]');
    scarItems = [];
    rows.forEach(function(row) {
      var key      = row.getAttribute('data-bb-line-key');
      var hasXLeft = !!row.querySelector('.cart-item__image-container .bb-cart-badges .bb-cart-badge--x-left');
      var hasLow   = !!row.querySelector('.cart-item__image-container .bb-cart-badges .bb-cart-badge--low-stock');
      var hasFlash = !!row.querySelector('.cart-item__image-container .bb-cart-badges .bb-cart-badge--flash');
      var hasAso   = row.getAttribute('data-bb-has-aso') === 'true';
      if (!hasXLeft && !hasLow && !hasFlash && !hasAso) return;

      var imgEl  = row.querySelector('.cart-item__image-container img');
      var imgUrl = imgEl ? (imgEl.getAttribute('src') || '') : '';
      if (imgUrl) imgUrl = imgUrl.replace(/(\.(jpe?g|png|gif|webp))(\?.*)?$/i, '_80x80$1');

      var type   = hasXLeft ? 'x-left' : (hasLow ? 'low-stock' : (hasFlash ? 'flash' : 'aso'));
      var invQty = parseInt(row.getAttribute('data-bb-inv-qty') || '0', 10);
      var badgesEl = row.querySelector('.cart-item__image-container .bb-cart-badges');

      scarItems.push({ key: key, imgUrl: imgUrl, type: type, invQty: invQty, badgesEl: badgesEl });
    });

    if (scarCfg && scarCfg.shuffle) {
      for (var i = scarItems.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = scarItems[i]; scarItems[i] = scarItems[j]; scarItems[j] = tmp;
      }
    }
  }

  function getScarIcon(item) {
    var cfg = scarCfg || {};
    if (item.type === 'x-left')    return cfg.iconXLeft    || '⚠️';
    if (item.type === 'low-stock') return cfg.iconLowStock || '📦';
    if (item.type === 'flash')     return cfg.iconFlash    || '⏰';
    return cfg.iconAso || '🔥';
  }

  function getScarText(item) {
    var cfg = scarCfg || {};
    if (item.type === 'x-left') {
      var tpl = cfg.textXLeft || 'Only {n} left in stock';
      return tpl.replace('{n}', item.invQty > 0 ? String(item.invQty) : '');
    }
    if (item.type === 'low-stock') return cfg.textLowStock || 'Low stock — selling fast';
    if (item.type === 'flash')     return cfg.textFlash    || 'Flash deal — limited time';
    return cfg.textAso || 'Almost sold out!';
  }

  function showNextScarNotif() {
    if (!scarCfg || scarCfg.enable === false) return;
    if (scarItems.length === 0) return;
    var maxSession = scarCfg.maxPerSession || 5;
    if (scarSession >= maxSession) return;

    var item = scarItems[scarIdx % scarItems.length];
    scarIdx++;
    scarSession++;

    var notif = document.getElementById('bb-scar-notif');
    if (!notif) return;

    var thumbEl   = notif.querySelector('.bb-scar-notif__thumb');
    var iconEl    = notif.querySelector('.bb-scar-notif__icon');
    var textEl    = notif.querySelector('.bb-scar-notif__text');
    var thumbWrap = notif.querySelector('.bb-scar-notif__thumb-wrap');

    if (thumbEl) {
      thumbEl.src = item.imgUrl || '';
      thumbEl.style.display = item.imgUrl ? '' : 'none';
    }

    if (thumbWrap) {
      var oldBadge = thumbWrap.querySelector('.bb-cart-badges');
      if (oldBadge) oldBadge.parentNode.removeChild(oldBadge);
      if (scarCfg.showBadgeOverlay !== false && item.badgesEl && item.badgesEl.children.length) {
        var clone = item.badgesEl.cloneNode(true);
        clone.removeAttribute('style');
        thumbWrap.appendChild(clone);
      }
    }

    if (iconEl) {
      var icon = getScarIcon(item);
      if (icon.trim().charAt(0) === '<') {
        iconEl.innerHTML = icon;
      } else {
        iconEl.textContent = icon;
      }
    }
    if (textEl) textEl.textContent = getScarText(item);
    notif.setAttribute('data-item-key', item.key || '');
    notif.setAttribute('aria-hidden', 'false');
    notif.classList.add('is-visible');

    if (scarTimer) clearTimeout(scarTimer);
    var dur = (scarCfg.duration != null) ? scarCfg.duration : 5000;
    scarTimer = setTimeout(function() { hideScarNotif(true); }, dur);
  }

  function hideScarNotif(scheduleNext) {
    var notif = document.getElementById('bb-scar-notif');
    if (notif) {
      notif.classList.remove('is-visible');
      notif.setAttribute('aria-hidden', 'true');
    }
    if (scarTimer) { clearTimeout(scarTimer); scarTimer = null; }
    if (scheduleNext && scarItems.length > 0) {
      var maxSession = (scarCfg && scarCfg.maxPerSession) || 5;
      if (scarSession < maxSession) {
        var intv = (scarCfg && scarCfg.interval != null) ? scarCfg.interval : 8000;
        scarTimer = setTimeout(showNextScarNotif, intv);
      }
    }
  }

  function initScarcityNotif() {
    scarCfg = parseScarCfg();
    if (!scarCfg || scarCfg.enable === false) return;

    collectScarItems();
    if (scarItems.length === 0) return;

    var closeBtn = document.getElementById('bb-scar-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() { hideScarNotif(false); });
    }

    var ctaBtn = document.getElementById('bb-scar-cta');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function() {
        var notif = document.getElementById('bb-scar-notif');
        var key   = notif ? notif.getAttribute('data-item-key') : '';
        hideScarNotif(false);
        if (key) {
          var row = document.querySelector('tr.cart-item[data-bb-line-key="' + key + '"]');
          if (row) {
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            row.classList.add('bb-item--highlight');
            setTimeout(function() { row.classList.remove('bb-item--highlight'); }, 750);
          }
        }
      });
    }

    var delay = (scarCfg.delay != null) ? scarCfg.delay : 3000;
    scarTimer = setTimeout(showNextScarNotif, delay);
  }

  function escHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ── Flash Sale Countdown ──────────────────────────────────────────────────
  function initFlashCountdown() {
    var bar = document.getElementById('bb-cdt-bar');
    if (!bar) return;

    var endMs = parseInt(bar.dataset.end, 10);
    if (!endMs || isNaN(endMs) || endMs <= Date.now()) {
      bar.style.display = 'none';
      return;
    }

    var dismissKey = 'bb_cdt_' + endMs;
    try { if (sessionStorage.getItem(dismissKey)) { bar.style.display = 'none'; return; } } catch (e) {}

    var timer = document.getElementById('bb-cdt-timer');
    var interval;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function updateTimer() {
      var diff = endMs - Date.now();
      if (diff <= 0) {
        bar.style.display = 'none';
        clearInterval(interval);
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (timer) {
        timer.innerHTML =
          '<span class="bb-cdt-seg">' + pad(h) + '</span>' +
          '<span class="bb-cdt-sep">:</span>' +
          '<span class="bb-cdt-seg">' + pad(m) + '</span>' +
          '<span class="bb-cdt-sep">:</span>' +
          '<span class="bb-cdt-seg">' + pad(s) + '</span>';
      }
    }

    updateTimer();
    interval = setInterval(updateTimer, 1000);

    var closeBtn = document.getElementById('bb-cdt-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.style.display = 'none';
        clearInterval(interval);
        try { sessionStorage.setItem(dismissKey, '1'); } catch (e) {}
      });
    }
  }

  // ── Edit Cart Carousel ────────────────────────────────────────────────────
  function initEditCarousel() {
    var carousel = document.querySelector('.bb-edit-carousel');
    if (!carousel || carousel._bbInited) return;
    carousel._bbInited = true;
    var dots = Array.from(document.querySelectorAll('.bb-edit-dot'));
    if (!dots.length) return;
    function updateDots() {
      var idx = carousel.offsetWidth > 0 ? Math.round(carousel.scrollLeft / carousel.offsetWidth) : 0;
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }
    carousel.addEventListener('scroll', updateDots, { passive: true });
  }

  // ── Edit Cart Measurements ────────────────────────────────────────────────
  function initEditMeasurements() {
    var bar     = document.getElementById('bb-cart-mobile-bar');
    var strip   = document.getElementById('bb-edit-meas-strip');
    var textEl  = document.getElementById('bb-edit-meas-text');
    var labelEl = document.getElementById('bb-edit-meas-label');
    var dataEl  = document.getElementById('bb-edit-meas-data');

    if (!strip) return;

    if (bar && bar.dataset.measEnable === 'false') {
      strip.classList.add('bb-meas-hidden');
      return;
    }
    if (!dataEl) return;

    var showLabel = !(bar && bar.dataset.measShowLabel === 'false');
    if (labelEl) {
      var lText = (bar && bar.dataset.measLabel) || 'Measurements';
      labelEl.textContent = lText + ':';
      labelEl.style.display = showLabel ? '' : 'none';
    }

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function getVariantId() {
      var form = document.querySelector('[id^="product-form-edit-"]');
      if (form) { var inp = form.querySelector('input[name="id"]'); if (inp) return inp.value; }
      return null;
    }

    function showMeasurements() {
      var vid = getVariantId();
      var text = (vid && data.variants && data.variants[vid]) ? data.variants[vid] : '';
      if (!text) text = data.product || '';
      if (textEl) textEl.textContent = text;
    }

    showMeasurements();

    var popup = document.querySelector('[data-edit-cart-popup]');
    if (popup) {
      if (popup._bbMeasHandler) popup.removeEventListener('change', popup._bbMeasHandler);
      popup._bbMeasHandler = function (e) {
        if (e.target && e.target.matches('input[type="radio"]')) setTimeout(showMeasurements, 150);
      };
      popup.addEventListener('change', popup._bbMeasHandler);
    }
  }

  // ── Size Guide Popup ─────────────────────────────────────────────────────
  function initSizeGuide() {
    var bar      = document.getElementById('bb-cart-mobile-bar');
    var strip    = document.getElementById('bb-edit-meas-strip');
    var trigger  = document.getElementById('bb-sg-trigger');
    var overlay  = document.getElementById('bb-sg-overlay');
    var closeBtn = document.getElementById('bb-sg-close');
    var titleEl  = document.getElementById('bb-sg-title');
    var body     = document.getElementById('bb-sg-body');
    var metaEl   = document.getElementById('bb-sg-meta');

    if (!overlay) return;

    var sgKey   = (bar && bar.dataset.sizeGuideKey) || 'size_guide';
    var sgTitle = (bar && bar.dataset.sgTitle)       || 'Size Guide';
    if (titleEl) titleEl.textContent = sgTitle;

    var guide = null;
    var chartTitle = '';
    if (metaEl) {
      try {
        var allMeta = JSON.parse(metaEl.textContent);
        var raw = allMeta[sgKey];
        if (raw) guide = (typeof raw === 'string') ? JSON.parse(raw) : raw;
        var sgChartKey = (bar && bar.dataset.sgChartTitle) || '';
        if (sgChartKey) {
          var rawTitle = allMeta[sgChartKey];
          if (rawTitle) chartTitle = typeof rawTitle === 'string' ? rawTitle : String(rawTitle);
        }
      } catch (e) { guide = null; }
    }

    if (!guide) {
      if (trigger) trigger.style.display = 'none';
      return;
    }

    if (trigger) trigger.style.display = '';

    function buildTableHtml(tabData) {
      var h = '';
      if (!tabData.headers || !tabData.rows) return h;
      h += '<div class="bb-sg-table-wrap"><table class="bb-sg-table"><thead><tr>';
      tabData.headers.forEach(function (col) { h += '<th>' + escHtml(String(col)) + '</th>'; });
      h += '</tr></thead><tbody>';
      tabData.rows.forEach(function (row) {
        h += '<tr>';
        row.forEach(function (cell, i) {
          var c = escHtml(String(cell));
          var num = parseFloat(String(cell));
          if (i === 0) {
            h += '<th>' + c + '</th>';
          } else if (!isNaN(num)) {
            h += '<td data-val="' + num + '">' + c + '</td>';
          } else {
            h += '<td>' + c + '</td>';
          }
        });
        h += '</tr>';
      });
      h += '</tbody></table></div>';
      if (tabData.note) h += '<p class="bb-sg-note">' + escHtml(tabData.note) + '</p>';
      return h;
    }

    function openGuide() {
      var tabDatas = (guide.tabs && guide.tabs.length) ? guide.tabs : (guide.headers ? [guide] : []);
      if (!tabDatas.length) return;

      var html = '';
      if (chartTitle) html += '<h4 class="bb-sg-section-title">' + escHtml(chartTitle) + '</h4>';

      if (tabDatas.length === 1) {
        html += buildTableHtml(tabDatas[0]);
      } else {
        html += '<div class="bb-sg-tabs">';
        tabDatas.forEach(function (t, i) {
          html += '<button type="button" class="bb-sg-tab' + (i === 0 ? ' is-active' : '') + '" data-tab="' + i + '">' + escHtml(t.name || '') + '</button>';
        });
        html += '</div>';
        tabDatas.forEach(function (t, i) {
          html += '<div class="bb-sg-tab-panel' + (i === 0 ? ' is-active' : '') + '" data-panel="' + i + '" data-base-unit="' + escHtml(t.unit || 'in') + '">';
          html += buildTableHtml(t);
          html += '</div>';
        });
      }

      var disclaimer = bar ? (bar.dataset.sgDisclaimer || '') : '';
      if (disclaimer) html += '<p class="bb-sg-disclaimer">' + escHtml(disclaimer) + '</p>';

      body.innerHTML = html;

      // Unit toggle bar — inserted between header and body (flex-shrink:0, doesn't scroll)
      var oldUnitBar = body.parentNode.querySelector('.bb-sg-unit-bar');
      if (oldUnitBar) oldUnitBar.parentNode.removeChild(oldUnitBar);

      var unitBar = document.createElement('div');
      unitBar.className = 'bb-sg-unit-bar';
      unitBar.innerHTML =
        '<span class="bb-sg-unit-lbl">Switch to</span>' +
        '<div class="bb-sg-unit-toggle">' +
          '<button type="button" class="bb-sg-unit-btn" data-unit="in">in</button>' +
          '<button type="button" class="bb-sg-unit-btn" data-unit="cm">cm</button>' +
        '</div>';
      body.parentNode.insertBefore(unitBar, body);

      var currentUnit = tabDatas[0].unit || 'in';

      function applyUnit(unit) {
        body.querySelectorAll('[data-val]').forEach(function (cell) {
          var orig = parseFloat(cell.dataset.val);
          if (isNaN(orig)) return;
          var panel = cell.closest('[data-panel]');
          var baseUnit = panel ? (panel.dataset.baseUnit || 'in') : (tabDatas[0].unit || 'in');
          var out;
          if (baseUnit === 'in' && unit === 'cm') {
            out = (orig * 2.54).toFixed(1);
          } else if (baseUnit === 'cm' && unit === 'in') {
            out = (orig / 2.54).toFixed(1);
          } else {
            out = String(orig);
          }
          cell.textContent = out;
        });
        currentUnit = unit;
        unitBar.querySelectorAll('.bb-sg-unit-btn').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.unit === unit);
        });
      }

      applyUnit(currentUnit);

      unitBar.querySelectorAll('.bb-sg-unit-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.unit !== currentUnit) applyUnit(btn.dataset.unit);
        });
      });

      // Tab switching
      body.querySelectorAll('.bb-sg-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.dataset.tab;
          body.querySelectorAll('.bb-sg-tab').forEach(function (b) { b.classList.remove('is-active'); });
          body.querySelectorAll('.bb-sg-tab-panel').forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var panel = body.querySelector('[data-panel="' + idx + '"]');
          if (panel) panel.classList.add('is-active');
          applyUnit(currentUnit);
        });
      });

      overlay.classList.remove('bb-meas-hidden');
      overlay.setAttribute('aria-hidden', 'false');
      pageLock('cart:size-guide');
    }

    function closeGuide() {
      var ub = body ? body.parentNode.querySelector('.bb-sg-unit-bar') : null;
      if (ub) ub.parentNode.removeChild(ub);
      overlay.classList.add('bb-meas-hidden');
      overlay.setAttribute('aria-hidden', 'true');
      pageUnlock('cart:size-guide');
    }

    if (trigger) trigger.addEventListener('click', openGuide);
    if (closeBtn) closeBtn.addEventListener('click', closeGuide);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeGuide();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.classList.contains('bb-meas-hidden')) closeGuide();
    });
  }

  // ── Edit Cart Price Split ─────────────────────────────────────────────────
  function splitEditPrice(priceEl) {
    if (!priceEl) return;
    var raw = priceEl.textContent || '';
    // Match: optional currency symbol/code, digits, optional decimal separator + 2 digits
    var m = raw.match(/^([^0-9]*)(\d[\d,]*)(\.\d{2})?([^0-9]*)$/);
    if (!m) return;
    var pre  = m[1] || '';   // currency prefix e.g. "$"
    var main = m[2] || '';   // integer part e.g. "20"
    var dec  = m[3] || '';   // decimal part e.g. ".29"
    var post = m[4] || '';   // trailing e.g. " USD"
    priceEl.innerHTML =
      '<span class="bb-edit-price-int">' + escHtml(pre + main) + '</span>' +
      (dec ? '<span class="bb-edit-price-dec">' + escHtml(dec) + '</span>' : '') +
      (post ? escHtml(post) : '');
  }

  function initEditPriceSplit() {
    var priceEl = document.querySelector('.bb-edit-price-main');
    if (!priceEl || priceEl._bbSplitInited) return;
    priceEl._bbSplitInited = true;
    splitEditPrice(priceEl);
    var obs = new MutationObserver(function () {
      obs.disconnect();
      splitEditPrice(priceEl);
      obs.observe(priceEl, { childList: true, subtree: true, characterData: true });
    });
    obs.observe(priceEl, { childList: true, subtree: true, characterData: true });
  }

  // ── Edit Cart ASO Text ────────────────────────────────────────────────────
  function initSizeAsoText() {
    var bar = document.getElementById('bb-cart-mobile-bar');
    if (!bar) return;
    var asoText = bar.dataset.asoText || 'Almost sold out';
    document.querySelectorAll('.bb-edit-size-aso').forEach(function (el) {
      var count = el.dataset.inv || '';
      el.textContent = asoText.replace('{n}', count);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-open-edit-cart]')) return;

    function runInits() {
      initEditCarousel();
      initEditPriceSplit();
      initEditMeasurements();
      initSizeGuide();
      initSizeAsoText();
    }

    var popup = document.querySelector('[data-edit-cart-popup]');
    if (!popup) { setTimeout(runInits, 500); return; }

    // Content already present (re-open without page reload)
    if (popup.querySelector('.bb-edit-action-bar')) { runInits(); return; }

    // Fire the instant the AJAX content lands — no fixed delay
    var obs = new MutationObserver(function () {
      if (popup.querySelector('.bb-edit-action-bar')) {
        obs.disconnect();
        runInits();
      }
    });
    obs.observe(popup, { childList: true, subtree: true });
    // Safety fallback if observer misses the injection
    setTimeout(function () { obs.disconnect(); runInits(); }, 1500);
  });

  // ── Toast ──────────────────────────────────────────────────────────────────
  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'bb-cta-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { t.classList.add('is-visible'); });
    });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 350);
    }, 2800);
  }

  // ── Boot ───────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
